import AxiosWrapper from "../../basecomp/base/AxiosWrapper";
import { fetchData } from "../apis/apis";


async function GetUserType(){
        console.log("in the getuser type");
        try{
        // let response = await AxiosWrapper.axiosGetCallWithToken("/ticket-tool/getusertype",new FormData())
        let response= fetchData("/getusertype",new FormData())
        console.log("user type is ",response);
        return response
        }
        catch(error){
                throw error
        }

}

export default GetUserType